import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { BudgetMacroItem } from '@libs/core/api';
import { CheckboxListOption } from '../checkbox-list/abstract-checkbox-list.component';

interface ProjectTaskForm {
  projectTask: FormControl<(BudgetMacroItem | undefined)[]>;
}

function buildProjectTaskForm(
  projectTask?: BudgetMacroItem
): FormGroup<ProjectTaskForm> {
  return new FormBuilder().group<ProjectTaskForm>({
    projectTask: new FormControl(projectTask ? [projectTask] : [], {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });
}

@Component({
  selector: 'ui-select-macroitem-modal',
  templateUrl: './select-macroitem-modal.component.html',
  styleUrls: ['./select-macroitem-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectProjectTaskModalComponent {
  @Input() set projectTasks(projectTasks: BudgetMacroItem[]) {
    this.options = [
      {
        label: '',
        options: projectTasks.map((projectTask) => ({
          label: `${projectTask.name}`,
          value: projectTask,
        })),
      },
    ];
  }
  @Input() projectTask!: BudgetMacroItem;
  options: CheckboxListOption[] = [];

  readonly form = buildProjectTaskForm(this.projectTask);

  constructor(private modalController: ModalController) {}

  back() {
    this.modalController.dismiss();
  }

  apply(form: FormGroup<ProjectTaskForm>) {
    if (form.valid) {
      this.modalController.dismiss(
        form.value.projectTask && form.value.projectTask[0]
      );
    }
  }
}
